import {
  DiscordVector,
  LinkedinVector,
  MediumVector,
  TelegramVector,
  Xvector,
} from "assets";
import { Images } from "assets/Images";
import { Typography } from "components/Atoms/Typography/Typography";
import HackenBadge from "components/Hacken/hacken";
import React from "react";
import { Link } from "react-router-dom";

const footerLinks = [
  { text: "COPYRIGHT 2025", link: "", className: "cursor-default" },
  { text: "TERMS AND CONDITIONS", link: "https://astranova.world/termsOfUse" },
  { text: "PRIVACY POLICY", link: "https://astranova.world/privacyPolicy" },
];

const moreLinks = [
  { text: "WHITEPAPER", link: "https://whitepaper.astranova.world/" },
  { text: "VISIT ASTRANOVA", link: "https://astranova.world/" },
];

const socialLinks = [
  { link: "https://astranovaofficial.medium.com/", image: <MediumVector /> },
  { link: "https://twitter.com/Astra__Nova", image: <Xvector /> },
  { link: "https://t.me/astranovaofficial", image: <TelegramVector /> },
  { link: "https://discord.com/invite/YQusFqaf6c", image: <DiscordVector /> },
  {
    link: "https://www.linkedin.com/company/astra-nova",
    image: <LinkedinVector />,
  },
];

export const Footer = () => {
  return (
    <div className="flex flex-col items-center justify-center max-w-[90%] md:max-w-[70%] mx-auto pb-5 gap-5">
      {/* Hacken Badge at the Top */}
      <HackenBadge />

      {/* Main Footer Content */}
      <div className="flex justify-center items-center flex-wrap gap-5 flex-col md:flex-row">
        {/* Left Section - Footer Links */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-x-10 gap-y-2 text-center">
          {/* First set of links */}
          <div className="flex gap-x-5 md:gap-x-10 items-center">
            {footerLinks.map((item, index) => (
              <div
                key={index}
                onClick={() => item.link && window.open(item.link, "_blank")}
                className={`text-xs text-text-light hover:text-text-secondary cursor-pointer ${item.className}`}
              >
                {item.text}
              </div>
            ))}
          </div>

          {/* Divider Line for Mobile */}
          <div className="py-1 md:hidden">
            <img src={Images.LINE} alt="Divider" />
          </div>

          {/* Second set of links */}
          <div className="flex gap-x-5 md:gap-x-10 items-center">
            {moreLinks.map((item, index) => (
              <div
                key={index}
                onClick={() => window.open(item.link, "_blank")}
                className="text-xs text-text-light hover:text-text-secondary cursor-pointer"
              >
                {item.text}
              </div>
            ))}
          </div>
        </div>

        {/* Social Links */}
        <div className="flex flex-col items-center justify-center gap-y-3">
          {/* Mobile Divider */}
          <div className="py-1 md:hidden">
            <img src={Images.LINE} alt="Divider" />
          </div>

          {/* Social Media Icons */}
          <div className="flex gap-x-5 items-center">
            {socialLinks.map((item, index) => (
              <Link to={item.link} target="_blank" key={index}>
                <div
                  className={` opacity-[75%] cursor-pointer text-text-primary hover:text-text-secondary`}
                >
                  {item.image}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
